// 联系方式校验规则：前端表单和 Cloudflare Functions 共用这一份（改这里两边同时生效）

// 全角转半角（１３８、＋、（）、－ 等），去掉首尾空格
const norm = v => String(v == null ? '' : v).normalize('NFKC').trim()

export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
export const isEmail = v => EMAIL_RE.test(norm(v))

// 全球电话（按 E.164，宽松不查号段，不支持分机号）：
// 1. 去掉空格、- . / 和括号
// 2. 开头可以是 +、00 或直接数字
// 3. 去掉 + / 00 后必须是 6–15 位纯数字
export function isPhone(v) {
  let s = norm(v).replace(/[\s\-./()]/g, '')
  if (s.startsWith('+')) s = s.slice(1)
  else if (s.startsWith('00')) s = s.slice(2)
  return /^\d{6,15}$/.test(s)
}

// Telegram：用户名 5–32 位字母、数字、下划线（可带 @ 或 t.me 链接），也可以填手机号
export const isTelegram = v => {
  const s = norm(v)
  return /^@?[A-Za-z0-9_]{5,32}$/.test(s) || /^(https?:\/\/)?t\.me\/[A-Za-z0-9_]{5,32}\/?$/i.test(s) || isPhone(s)
}

// 微信号：字母开头，6–20 位字母、数字、_ 或 -；也可以填绑定的手机号
export const isWechat = v => {
  const s = norm(v)
  return /^[A-Za-z][-_A-Za-z0-9]{5,19}$/.test(s) || isPhone(s)
}

export const CONTACT_RULES = { phone: isPhone, telegram: isTelegram, wechat: isWechat }

// 官网联系表单的「电话 / 微信 / Telegram」三合一格子：没法按单一格式校验，
// 只挡乱填：至少 5 个字符，且要包含字母或数字
export const isAnyIm = v => {
  const s = norm(v)
  return s.length >= 5 && /[A-Za-z0-9]/.test(s)
}
